<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'reports.filter.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'reports.filter.date' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date" (selectChange)="navigate()"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'storage.invoice.supplier' | transloco }}</small>
              <app-suppliers-search [(ngModel)]="params.supplierId" [storeIds]="[params.storeId]" (selectChange)="navigate()"></app-suppliers-search>
            </div>
          </div>

          <button type="button" (click)="resetFilter()" class="btn btn-outline-primary m--margin-top-15">
            {{ 'reset.list' | transloco }}
          </button>

          <div *ngIf="list.length && !isLoading.list" class="block-table-scroll m--margin-top-30">
            <table class="m--margin-top-10 m--margin-bottom-40 table-report" style="width:100%; border-collapse: collapse;">
              <thead>
              <tr>
                <th class="text-align-center">{{ 'receivables-payables.table.head.uin' | transloco }}</th>
                <th class="text-align-center">{{ 'receivables-payables.table.head.title' | transloco }}</th>
                <th class="text-align-center">{{ 'receivables-payables.table.head.payable' | transloco }}</th>
                <th class="text-align-center">{{ 'receivables-payables.table.head.receivable' | transloco }}</th>
                <th class="text-align-center">{{ 'receivables-payables.table.head.balance' | transloco }}</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let even = even;let i = index; let r of list">
                <tr>
                  <td class="txt-center">{{ r.uin }}</td>
                  <td>{{ r.title }}</td>
                  <td class="txt-right">{{ r.payable }}</td>
                  <td class="txt-right">{{ r.receivable }}</td>
                  <td class="txt-right">{{ r.balance }}</td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>

          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>
        </div>
      </div>
    </div>
  </div>
</div>
